import * as React from "react";
import type { SVGProps } from "react";
const SvgReloadWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.5 10.275V7.5M10.5 12.36a.14.14 0 1 0 .14.14.14.14 0 0 0-.14-.14"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.212 14.712a6.65 6.65 0 0 1-4.712 1.954A6.667 6.667 0 0 1 3.833 10c0-.507.062-.998.169-1.473"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m2.167 10 1.666-1.667L5.5 10M18.833 10l-1.666 1.667L15.5 10"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.786 5.286A6.667 6.667 0 0 1 17.166 10c0 .506-.06.998-.168 1.472"
    />
  </svg>
);
export default SvgReloadWarning;
